import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function findSeaExportJobByNo(data) {
  return request({
    url: URL.seaExport.findSeaExportJobByNo,
    method: 'post',
    data
  })
}

export function findSeaExportJobByUuid(data) {
  return request({
    url: URL.seaExport.findSeaExportJobByUuid,
    method: 'post',
    data
  })
}

export function queryFmVerify(data) {
  return request({
    url: URL.seaExport.queryFmVerify,
    method: 'post',
    data
  })
}

export function advancedQuery(data) {
  return request({
    url: URL.seaExport.advancedQuery,
    method: 'post',
    data
  })
}

export function advancedQueryForVerify(data) {
  return request({
    url: URL.seaExport.advancedQueryForVerify,
    method: 'post',
    data
  })
}

export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.seaExport.queryLastModifyBookingByDay,
    method: 'post',
    data
  })
}

export function getSeaExportJobByUuid(uuid) {
  return request({
    url: URL.seaExport.getSeaExportJobByUuid,
    method: 'get',
    params: { uuid }
  })
}

// 加载海出Job的关联实体信息
export function loadSeaExportJobRelated(data) {
  return request({
    url: URL.seaExport.loadSeaExportJobRelated,
    method: 'post',
    data: data
  })
}

export function cargoDocSeaExportSearch(params) {
  return request({
    url: URL.seaExport.cargoDocSeaExportSearch,
    method: 'get',
    params
  })
}

export function loadLclJobSeaCargoDocList(data) {
  return request({
    url: URL.seaExport.loadLclJobSeaCargoDocList,
    method: 'post',
    data
  })
}

export function saveSeaBookingSpace(data, fullError, forbidAlert) {
  return request({
    url: URL.seaExport.saveSeaBookingSpace,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

export function batchSaveSeaBookingSpaceAndBook(data) {
  return request({
    url: URL.seaExport.batchSaveSeaBookingSpaceAndBook,
    method: 'post',
    data
  })
}

export function validateDelJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.validateDelJob,
    method: 'post',
    data
  })
}

export function batchDeleteJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.batchDeleteJob,
    method: 'delete',
    data
  })
}

// 向主票中批量加入业务
export function batchAddJob(data, lclMasterUuid, mbl, location) {
  return request({
    url: URL.seaExport.batchAddJob,
    method: 'post',
    data,
    params: { lclMasterUuid, mbl, location }
  })
}

// 从主票中批量移除业务
export function batchRemoveJob(data, location) {
  return request({
    url: URL.seaExport.batchRemoveJob,
    method: 'delete',
    data,
    params: { location }
  })
}

// 校验选中小票中是否包含分摊费用
export function checkJobForShared(data) {
  return request({
    url: URL.seaExport.checkJobForSharedUrl,
    method: 'post',
    data
  })
}

export function getTrackingInfoByLob(lob) {
  return request({
    url: URL.seaExport.getTrackingInfoByLob,
    method: 'get',
    params: { lob }
  })
}

// 通过业务类型，获取SOP状态
export function getTrackingListByLob(lob) {
  return request({
    url: URL.seaExport.getTrackingListByLob,
    method: 'get',
    params: { lob }
  })
}

// 获取多模板下的节点信息
export function getTrackingBySopTemplateKeys(sopTemplateKeys) {
  return request({
    url: URL.seaExport.getTrackingBySopTemplateKeys,
    method: 'get',
    params: { sopTemplateKeys }
  })
}

export function getTrackingDetailByTrackingUuid(trackingUuid) {
  return request({
    url: URL.seaExport.getTrackingDetailByTrackingUuid,
    method: 'get',
    params: { trackingUuid }
  })
}

export function updateJobTrackingInfo(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.updateJobTrackingInfo,
    method: 'post',
    data
  })
}

export function canBatchShutout(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.canBatchShutout,
    method: 'post',
    data
  })
}

export function batchShutout(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.batchShutout,
    method: 'post',
    data
  })
}

export function checkChargeStateVerify(requestBody) {
  return request({
    url: URL.seaExport.checkChargeStateVerify,
    method: 'post',
    data: requestBody
  })
}

export function batchPreCommit(requestBody) {
  return request({
    url: URL.seaExport.batchPreCommit,
    method: 'post',
    data: requestBody
  })
}

export function batchCommit(requestBody) {
  return request({
    url: URL.seaExport.batchCommit,
    method: 'post',
    data: requestBody
  })
}

export function getVoyagesByVesselId(vesselId) {
  return request({
    url: URL.seaExport.getVoyagesByVesselId,
    method: 'get',
    params: { vesselId }
  })
}

export function batchTransship(requestBody) {
  return request({
    url: URL.seaExport.batchTransship,
    method: 'post',
    data: requestBody
  })
}

export function checkJobHasContainer(requestBody) {
  return request({
    url: URL.seaExport.checkJobHasContainer,
    method: 'post',
    data: requestBody
  })
}

export function updateJobContainerLoadType(requestBody) {
  return request({
    url: URL.seaExport.updateJobContainerLoadType,
    method: 'post',
    data: requestBody
  })
}

export function statisticsJobs(requestBody) {
  return request({
    url: URL.seaExport.statisticsJobs,
    method: 'post',
    data: requestBody
  })
}

export function getSeaEqList(jobUuid) {
  return request({
    url: URL.seaExport.getSeaEqList,
    method: 'get',
    params: { jobUuid }
  })
}

export function batchSaveCharge(requestBody) {
  return request({
    url: URL.seaExport.batchSaveCharge,
    method: 'post',
    data: requestBody
  })
}

export function batchCheckRemoveCharge(requestBody) {
  return request({
    url: URL.seaExport.batchCheckRemoveCharge,
    method: 'post',
    data: requestBody
  })
}

export function batchRemoveCharge(requestBody, location) {
  return request({
    url: URL.seaExport.batchRemoveCharge,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function getChargeList(jobUuid) {
  return request({
    url: URL.seaExport.getChargeList,
    method: 'post',
    data: { 'jobUuid': jobUuid }
  })
}

// 根据jobUuid获取费用详细信息列表
export function getChargeDetails(params) {
  return request({
    url: URL.seaExport.getChargeDetails,
    method: 'post',
    data: params
  })
}

// 根据主票jobUuid获取所有小票费用
export function getAllSlaveChargeList(jobUuid) {
  return request({
    url: URL.seaExport.getAllSlaveChargeList,
    method: 'get',
    params: { jobUuid }
  })
}

// 根据主票jobUuid获取所有小票提单
export function getAllSlaveCargoDocList(jobUuid, lob) {
  return request({
    url: URL.seaExport.getAllSlaveCargoDocList,
    method: 'get',
    params: { jobUuid, lob }
  })
}

export function batchEditCharge(requestBody) {
  return request({
    url: URL.seaExport.batchEditCharge,
    method: 'post',
    data: requestBody
  })
}

export function shutOut(data) {
  return request({
    url: URL.seaExport.shutOut,
    method: 'post',
    data
  })
}

export function getChargeIsInvoice(jobUuid) {
  return request({
    url: URL.seaExport.getChargeIsInvoice,
    method: 'get',
    params: { jobUuid }
  })
}

export function getLclSlaves(jobUuid) {
  return request({
    url: URL.seaExport.getSeaExportLclSlaves, // 返回 SeaExportJob 结构对象
    method: 'get',
    params: { jobUuid }
  })
}

export function getLclSlavesAndManifests(jobUuid) {
  return request({
    url: URL.seaExport.getLclSlavesAndManifests,
    method: 'get',
    params: { jobUuid }
  })
}

export function commit(jobUuid, operateNameCode, isPreCommit, officeId, location) {
  return request({
    url: URL.seaExport.commit,
    method: 'get',
    params: { jobUuid, operateNameCode, isPreCommit, officeId, location }
  })
}

export function calculateProfit(jobUuid, operateNameCode, isPrintOpr, allSubmitFcl, isPreCommit, officeId, optName = '', location) {
  return request({
    url: URL.seaExport.calculateProfit,
    method: 'get',
    params: { jobUuid, operateNameCode, isPrintOpr, allSubmitFcl, isPreCommit, officeId, optName, location }
  })
}

export function printProfit(jobUuid, operateNameCode, officeId, optName = '', location) {
  return request({
    url: URL.seaExport.printProfit,
    method: 'get',
    params: { jobUuid, operateNameCode, officeId, optName, location }
  })
}

export function prePrintProfit(jobUuid, officeId) {
  return request({
    url: URL.seaExport.prePrintProfit,
    method: 'get',
    params: { jobUuid, officeId }
  })
}

export function saveJobInfo(data) {
  return request({
    url: URL.seaExport.saveJobInfo,
    method: 'post',
    data
  })
}

export function feedbackBookingData(data) {
  return request({
    url: URL.seaExport.feedbackBookingData,
    method: 'post',
    data
  })
}

export function getCargoDoc(params) {
  return request({
    url: URL.seaExport.getCargoDoc,
    method: 'get',
    params
  })
}

export function updateSeaJobsFromReceipt(params) {
  return request({
    url: URL.seaExport.updateSeaJobsFromReceipt,
    method: 'post',
    params
  })
}

export function loadJobParams(data) {
  return request({
    url: URL.seaExport.loadJobParams,
    method: 'post',
    data
  })
}

export function getJob(jobNo, crossTenantId) {
  return request({
    url: URL.seaExport.getJob,
    method: 'get',
    params: { jobNo, crossTenantId }
  })
}

export function getRelatedJob(jobNo) {
  return request({
    url: URL.seaExport.getRelatedJob,
    method: 'get',
    params: { jobNo }
  })
}
export function getTrustFromJob(jobNo, tenantId) {
  return request({
    url: URL.seaExport.getTrustFromJob,
    method: 'get',
    params: { jobNo, tenantId }
  })
}

export function checkingConsignationJob(jobUuid) {
  return request({
    url: URL.seaExport.checkingConsignationJob,
    method: 'get',
    params: { jobUuid }
  })
}

export function saveCloneJob(data) {
  return request({
    url: URL.seaExport.saveCloneJob,
    method: 'post',
    data
  })
}

export function crossTenantJob(data) {
  return request({
    url: URL.seaExport.crossTenantJob,
    method: 'post',
    data
  })
}

export function queryJobStateUpdateLog(jobUuid) {
  return request({
    url: URL.seaExport.queryJobStateUpdateLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryBusinessAdjustmentLog(jobUuid) {
  return request({
    url: URL.seaExport.queryBusinessAdjustmentLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function ediUpdateLog(jobUuid) {
  return request({
    url: URL.seaExport.ediUpdateLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryMessageLog(jobUuid) {
  return request({
    url: URL.seaExport.queryMessageLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryJobNoRule(type) {
  return request({
    url: URL.seaExport.queryJobNoRule,
    method: 'get',
    params: { type }
  })
}

export function doCopyJob(data) {
  return request({
    url: URL.seaExport.doCopyJob,
    method: 'post',
    data
  })
}

export function importOrderJob(data) {
  return request({
    url: URL.seaExport.importOrderJob,
    method: 'post',
    data
  })
}

// 批量复制小票，组装数据返回给前台
export function batchCloneLcLJob(params) {
  return request({
    url: URL.seaExport.batchCloneLcLJob,
    method: 'get',
    params
  })
}

// 根据job拼箱主票和查询条件查询 隐含条件：未拼票的job..... job:SeaExportJob-主票的uuid
export function getSeaExportJobsByLclMasterJob(branchId, data) {
  return request({
    url: URL.seaExport.getSeaExportJobsByLclMasterJob + '/' + branchId,
    method: 'post',
    data: data
  })
}

export function isContractExpiredForbidCreateJob(cmpIdx) {
  return request({
    url: URL.seaExport.isContractExpiredForbidCreateJob,
    method: 'get',
    params: { cmpIdx }
  })
}

export function saveCopyJob(data) {
  return request({
    url: URL.seaExport.saveCopyJob,
    method: 'post',
    data
  })
}

// 加载edi回执状态
export function queryEDIFeedBackState(params) {
  return request({
    url: URL.seaExport.queryEDIFeedBackState,
    method: 'get',
    params
  })
}

export function splitMaster(data) {
  return request({
    url: URL.seaExport.splitMaster,
    method: 'post',
    data
  })
}

export function getSeaExportLclSlaves(jobUuid) {
  return request({
    url: URL.seaExport.getSeaExportLclSlaves,
    method: 'get',
    params: { jobUuid }
  })
}

export function shareCharges(data) {
  return request({
    url: URL.seaExport.shareCharges,
    method: 'put',
    data
  })
}

export function shareChargesNew(data) {
  return request({
    url: URL.seaExport.shareChargesNew,
    method: 'put',
    data
  })
}

// 费用分摊
export function chargeShare(data) {
  return request({
    url: URL.seaExport.chargeShare,
    method: 'post',
    data
  })
}

// 搜索没有并单过的Job
export function findNoJoinSeaExportJob(params) {
  return request({
    url: URL.seaExport.findNoJoinSeaExportJob,
    method: 'get',
    params
  })
}

// 移除并单操作
export function unJointSlavesHblOrMbl(data) {
  return request({
    url: URL.seaExport.unJointSlavesHblOrMbl,
    method: 'post',
    data
  })
}

// 移除形式分单并单操作
export function unJointSlavesHawb2(data) {
  return request({
    url: URL.seaExport.unJointSlavesHawb2,
    method: 'post',
    data
  })
}

// 获取业务的sop信息
export function getJobSopStates(data) {
  return request({
    url: URL.seaExport.getJobSopStates,
    method: 'post',
    data
  })
}

// 检查字段值是否重复
export function checkJobFiledExist(data) {
  return request({
    url: URL.seaExport.checkJobFiledExist,
    method: 'post',
    data
  })
}

// 确认Job是否存在 默认查询三个月内
export function isExistMBL(params) {
  return request({
    url: URL.seaExport.isExistMBL,
    method: 'get',
    params
  })
}

export function isExistMBLSeaExport(params) {
  return request({
    url: URL.seaExport.isExistMBLSeaExport,
    method: 'get',
    params
  })
}

// 提单号的适用分公司（HQ除外）不等于该业务的操作分公司或者提单适用部门（HQ除外）
export function isExistMBLNotCurrentCompany(params) {
  return request({
    url: URL.seaExport.isExistMBLNotCurrentCompany,
    method: 'get',
    params
  })
}

// 确认海运进口Job是否存在 默认查询三个月内
export function isExistSIMBL(params) {
  return request({
    url: URL.seaExport.isExistSIMBL,
    method: 'get',
    params
  })
}

// 确认Job是否存在 默认查询三个月内
export function isExistHBL(params) {
  return request({
    url: URL.seaExport.isExistHBL,
    method: 'get',
    params
  })
}

// 确认 业务参考号是否 存在
export function isExistCustomerRefNo(params) {
  return request({
    url: URL.seaExport.isExistCustomerRefNo,
    method: 'get',
    params
  })
}

// 确认SO NO是否存在
export function isExistSoNo(params) {
  return request({
    url: URL.seaExport.isExistSoNo,
    method: 'get',
    params
  })
}

// 复制舱位
export function cloneCabin(data, jobUuid) {
  return request({
    url: URL.seaExport.cloneCabin,
    method: 'post',
    data,
    params: { jobUuid }
  })
}

// 订舱预审 审核通过接口
export function approved(data, officeId) {
  return request({
    url: URL.seaExport.approved,
    method: 'post',
    data,
    params: { officeId }
  })
}

//
export function preVerifyReject(jobKey, remark, preverifyState) {
  return request({
    url: URL.seaExport.preVerifyReject,
    method: 'post',
    params: { jobKey, remark, preverifyState }
  })
}

export function batchPreVerifyReject(params) {
  return request({
    url: URL.seaExport.batchPreVerifyReject,
    method: 'post',
    data: params
  })
}

// 复制舱位
export function updateOrderCabinAudit(data) {
  return request({
    url: URL.seaExport.updateOrderCabinAudit,
    method: 'post',
    data
  })
}

// 出口转进口
export function createImportByExportJob(data) {
  return request({
    url: URL.seaExport.createImportByExportJob,
    method: 'post',
    data
  })
}
//  同步委托费用
export function syncJobCharge(charges, jobNo, location) {
  return request({
    url: URL.seaExport.syncJobCharge,
    method: 'post',
    data: charges,
    params: { jobNo, location }
  })
}
//  同步委托费用
export function asyncChargesToImportJob(params) {
  return request({
    url: URL.seaExport.asyncChargesToImportJob,
    method: 'get',
    params
  })
}
// 组合业务
export function combinationJob(data) {
  return request({
    url: URL.seaExport.combinationJob,
    method: 'post',
    data
  })
}
// 拆分业务
export function splitJob(params) {
  return request({
    url: URL.seaExport.splitJob,
    method: 'get',
    params
  })
}
// 组合业务时验证业务是否被使用
export function validateForCombination(data) {
  return request({
    url: URL.seaExport.validateForCombination,
    method: 'post',
    data
  })
}

// 整箱，BCF类型业务MBL重复不允许保存
export function checkMBLNoRepeat(params) {
  return request({
    url: URL.seaExport.checkMBLNoRepeat,
    method: 'get',
    params
  })
}

// 提单制作-保存
export function documentSave(data) {
  return request({
    url: URL.seaExport.documentSave,
    method: 'post',
    data
  })
}

export function subscribeSeaBookingSpace(params) {
  return request({
    url: URL.seaExport.seaBookingSpaceSubscribe,
    method: 'post',
    params
  })
}

export function subscribeSeaBookingSpaceSync(params) {
  return request({
    url: URL.seaExport.seaBookingSpaceSubscribeSync,
    method: 'post',
    params
  })
}

export function getSeaBookingSpaceSubscriptionStatus(params) {
  return request({
    url: URL.seaExport.seaBookingSpaceSubscriptionStatus,
    method: 'post',
    params
  })
}

// 获取数据推送结果
export function getPushResultLog(requestBody) {
  return request({
    url: URL.seaExport.getPushResultLog,
    method: 'post',
    data: requestBody
  })
}

// 通过jobKeys获取数据推送结果
export function getPushResultLogByJobKeys(requestBody) {
  return request({
    url: URL.seaExport.getPushResultLogByJobKeys,
    method: 'post',
    data: requestBody
  })
}

// 获取数据推送结果：ApiReqLog
export function getPushResultByReqLog(requestBody) {
  return request({
    url: URL.seaExport.getPushResultByReqLog,
    method: 'post',
    data: requestBody
  })
}

// 通过jobKeys获取数据推送结果：ApiReqLog
export function getPushResultByReqLogByJobKeys(requestBody) {
  return request({
    url: URL.seaExport.getPushResultByReqLogByJobKeys,
    method: 'post',
    data: requestBody
  })
}

// 重发订单信息
export function sendOrder(requestBody) {
  return request({
    url: URL.seaExport.sendOrder,
    method: 'post',
    data: requestBody
  })
}

// 重发订单信息（通过jobKeys）
export function sendOrderByJobKeys(jobKeys) {
  return request({
    url: URL.seaExport.sendOrderByJobKeys,
    method: 'post',
    data: jobKeys
  })
}

// 重发轨迹信息
export function sendTracking(requestBody) {
  return request({
    url: URL.seaExport.sendTracking,
    method: 'post',
    data: requestBody
  })
}

// 重发轨迹信息（通过jobKeys）
export function sendTrackingByJobKeys(jobKeys) {
  return request({
    url: URL.seaExport.sendTrackingByJobKeys,
    method: 'post',
    data: jobKeys
  })
}

// 重发文件信息
export function sendFile(requestBody) {
  return request({
    url: URL.seaExport.sendFile,
    method: 'post',
    data: requestBody
  })
}

// 重发文件信息（通过jobKeys）
export function sendFileByJobKeys(jobKeys) {
  return request({
    url: URL.seaExport.sendFileByJobKeys,
    method: 'post',
    data: jobKeys
  })
}

export function batchDeletedByFileId(data) {
  return request({
    url: URL.seaExport.batchDeletedByFileId,
    method: 'post',
    data
  })
}

// 获取文件信息
export function getOcFileList(requestBody) {
  return request({
    url: URL.seaExport.getOcFileList,
    method: 'post',
    data: requestBody
  })
}

// 通过jobKeys获取文件信息
export function getOcFileListByJobKeys(jobKeys) {
  const data = new FormData()
  data.append('jobKeys', jobKeys)
  return request({
    url: URL.seaExport.getOcFileListByJobKeys,
    method: 'post',
    data
  })
}

export function createCrossTenantImportByExportJob(jobUuid, location, branchId) {
  return request({
    url: URL.seaExport.createCrossTenantImportByExportJob,
    method: 'get',
    params: { jobUuid, location, branchId }
  })
}

export function getRelatedSiJob(jobNo) {
  return request({
    url: URL.seaExport.getRelatedSiJob,
    method: 'get',
    params: { jobNo }
  })
}

export function executeRuleEngine(params) {
  return request({
    url: URL.act.releaseDocRule.executeRuleEngine,
    method: 'get',
    params
  })
}

export function manualTriggerAndUpate(params) {
  return request({
    url: URL.act.releaseDocRule.manualTriggerAndUpate,
    method: 'get',
    params
  })
}

export function writeOffManualTriggerAndUpate(data) {
  return request({
    url: URL.act.releaseDocRule.writeOffManualTriggerAndUpate,
    method: 'put',
    data
  })
}

// 修改放单状态
export function updateReleasestate(params) {
  return request({
    url: URL.act.releaseDocRule.updateReleasestate,
    method: 'put',
    params
  })
}

export function updateDocBliStatus(data) {
  return request({
    url: URL.act.releaseDocRule.updateDocBliStatus,
    method: 'put',
    data
  })
}

// 海运出口转进口，二次同步信息
export function syncRelatedJob(data) {
  return request({
    url: URL.seaExport.syncRelatedJob,
    method: 'post',
    data
  })
}

// 批量修改箱号封号
export function batchUpdateContainerAndSealNo(params) {
  return request({
    url: URL.seaExport.batchUpdateContainerAndSealNo,
    method: 'post',
    data: params
  })
}

// 批量修改箱型箱种
export function batchUpdateEqSizeType(jobKeys, originEqSize, originEqType, newEqSize, newEqType, lob) {
  return request({
    url: URL.seaExport.batchUpdateEqSizeType,
    method: 'post',
    data: jobKeys,
    params: { originEqSize, originEqType, newEqSize, newEqType, lob }
  })
}
// 批量获取业务箱子
export function batchLoadJobContainers(data) {
  return request({
    url: URL.seaExport.batchLoadJobContainersUrl,
    method: 'post',
    data
  })
}

export function batchUploadFileForJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.batchMatchUrl,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

//
export function queryCarrierCodeFunc(data) {
  return request({
    url: URL.seaExport.queryCarrierCodeUrl,
    method: 'post',
    data
  })
}

// 批量修改本地服务
export function batchUpdateLocalService(jobKeys, columnName, checked, customsBroker) {
  return request({
    url: URL.seaExport.batchUpdateLocalService,
    method: 'post',
    data: jobKeys,
    params: { columnName, checked, customsBroker }
  })
}

// 批量修改目的港服务
export function batchUpdateDestinationPortService(jobKeys, columnName, checked) {
  return request({
    url: URL.seaExport.batchUpdateDestinationPortService,
    method: 'post',
    data: jobKeys,
    params: { columnName, checked }
  })
}

// 批量分配主单号
export function batchAssignMbl(jobKeys) {
  return request({
    url: URL.seaExport.batchAssignMbl,
    method: 'post',
    data: jobKeys
  })
}

// 加载海管家回执
export function querySeaHouseChomanifes(params) {
  return request({
    url: URL.seaExport.querySeaHouseChomanifes,
    method: 'get',
    params
  })
}
// 加载海管家回执
export function querySeahouseLoadreceipt(params) {
  return request({
    url: URL.seaExport.querySeahouseLoadreceipt,
    method: 'get',
    params
  })
}

// 生成HB/l No.
export function generateHblNo(data) {
  return request({
    url: URL.seaExport.generateHblNo,
    method: 'post',
    data
  })
}
// 简道云发送接口
export function jdySendPoItems(data) {
  return request({
    url: URL.seaExport.jdySendPoItems,
    method: 'post',
    data
  })
}
// 简道云解锁
export function jdyUnlockStatus(jobKeys) {
  return request({
    url: URL.seaExport.jdyUnlockStatus,
    method: 'post',
    data: jobKeys
  })
}

export function isExistScNo(data) {
  return request({
    url: URL.seaExport.isExistScNo,
    method: 'post',
    data
  })
}

export function complexQuerySeJobs(data) {
  return request({
    url: URL.seaExport.complexQuerySeJobs,
    method: 'post',
    data
  })
}

export function batchUpdateDestinationAgentFunc(data) {
  return request({
    url: URL.seaExport.batchUpdateDestinationAgentUrl,
    method: 'post',
    data
  })
}

export function batchUpdateCarryingCmpFunc(data) {
  return request({
    url: URL.seaExport.batchUpdateCarryingCmpUrl,
    method: 'post',
    data
  })
}

// 尾程同步
export function syncFinalStep(data) {
  return request({
    url: URL.seaExport.syncFinalStep,
    method: 'post',
    data
  })
}
